import {
  CMARKDOWNVISUAL_MODE,
  type CmarkdownvisualMode,
} from "./CmarkdownvisualModeContext";

export enum CmarkdownvisualRenderSurface {
  Compact = "compact",
  Expanded = "expanded",
}

enum CmarkdownvisualRenderStateKey {
  Compact = "compact",
  Canvas = "canvas",
  Modal = "modal",
}

export interface CmarkdownvisualRenderState {
  mode: CmarkdownvisualMode;
  surface: CmarkdownvisualRenderSurface;
}

interface CmarkdownvisualRenderStateInput {
  hasCompact: boolean;
  isExpanded: boolean;
  isModalOpen: boolean;
}

const RENDER_STATE_BY_KEY: Record<
  CmarkdownvisualRenderStateKey,
  CmarkdownvisualRenderState
> = {
  [CmarkdownvisualRenderStateKey.Compact]: {
    mode: CMARKDOWNVISUAL_MODE.Compact,
    surface: CmarkdownvisualRenderSurface.Compact,
  },
  [CmarkdownvisualRenderStateKey.Canvas]: {
    mode: CMARKDOWNVISUAL_MODE.Canvas,
    surface: CmarkdownvisualRenderSurface.Expanded,
  },
  [CmarkdownvisualRenderStateKey.Modal]: {
    mode: CMARKDOWNVISUAL_MODE.Modal,
    surface: CmarkdownvisualRenderSurface.Expanded,
  },
};

function getCmarkdownvisualRenderStateKey({
  hasCompact,
  isExpanded,
  isModalOpen,
}: CmarkdownvisualRenderStateInput): CmarkdownvisualRenderStateKey {
  if (isModalOpen) {
    return CmarkdownvisualRenderStateKey.Modal;
  }

  if (!isExpanded && hasCompact) {
    return CmarkdownvisualRenderStateKey.Compact;
  }

  return CmarkdownvisualRenderStateKey.Canvas;
}

export function getCmarkdownvisualRenderState(
  input: CmarkdownvisualRenderStateInput,
): CmarkdownvisualRenderState {
  return RENDER_STATE_BY_KEY[getCmarkdownvisualRenderStateKey(input)];
}
